import clsx from 'clsx';
import Link from 'next/link';
import React, { useMemo } from 'react';
import Breadcrumbs from './Breadcrumbs';
import MetaData from './MetaData';
import styles from './styles.module.scss';
import AvatarList from '../Avatars';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ArticleHeader = _ref => {
  let {
    heading,
    subHeading,
    className,
    breadcrumbs = [],
    authors,
    reviewer,
    updatedAt,
    createdAt
  } = _ref;
  const authorAvatars = useMemo(() => authors === null || authors === void 0 ? void 0 : authors.map(author => ({
    alt: author.fullName,
    src: author.avatarUrl || ''
  })), [authors]);
  return /*#__PURE__*/_jsxs("header", {
    className: clsx(styles.container, className),
    children: [/*#__PURE__*/_jsxs("hgroup", {
      className: styles.main,
      children: [breadcrumbs.length ? /*#__PURE__*/_jsx(Breadcrumbs, {
        items: breadcrumbs
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("h1", {
        className: styles.heading,
        children: heading
      }), subHeading && /*#__PURE__*/_jsx("p", {
        className: styles.subHeading,
        children: subHeading
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.meta,
      children: [/*#__PURE__*/_jsx(AvatarList, {
        className: styles.meta__avatars,
        items: authorAvatars
      }), /*#__PURE__*/_jsx(MetaData, {
        className: styles.meta__content,
        authors: authors,
        reviewer: reviewer,
        updatedAt: updatedAt,
        createdAt: createdAt
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.disclaimer,
      children: /*#__PURE__*/_jsxs("p", {
        className: styles.legalCopy,
        children: ["Learn about our", ' ', /*#__PURE__*/_jsx(Link, {
          href: "/editorial-policy",
          children: "editorial policies"
        }), " and", ' ', /*#__PURE__*/_jsx(Link, {
          href: "/terms-and-conditions",
          children: "terms & conditions"
        })]
      })
    })]
  });
};

export default ArticleHeader;